
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ProgramsHeroSection from './components/ProgramsHeroSection';
import ProgramsListSection from './components/ProgramsListSection';
import MethodologySection from './components/MethodologySection';

export default function Programs() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <ProgramsHeroSection />
        <ProgramsListSection />
        <MethodologySection />
      </main>
      <Footer />
    </div>
  );
}
